export const RIGHT_ALIGNED_LANGUAGES = [
    'fa', // Farsi
    'ar', // Arabic
    'heb', // Hebrew
    'ku', 'kur' // Kurdish
];
